<div class="item">
  <app-photo
    [size]="'m'"
    [rounded]="true"
    [type]="'chat'"
    [id]="item.isAvatarExists ? item.chatId : undefined"
    [text]="item.chatName"
    [showPreview]="false"
  ></app-photo>

  <div class="item__info">
    <div class="row">
      <div class="item__title text_truncate">{{ item.chatName }}</div>
      <div class="item__badge">
        <app-icon
          *ngIf="item.settings?.muted"
          class="text_color-grey"
          src="bell-off"
          size="16px"
          [tuiHint]="'components.listItemChats.labels.volumeOff' | translate"
        ></app-icon>

        <div *ngIf="item.lastChatMessage" class="text_size-s text_color-grey">
          {{ item.lastChatMessage.timestamp | timestampToDate: 'string' }}
        </div>
      </div>
    </div>

    <div *ngIf="lastChatMessage">
      <div *ngIf="!isSelf && !!senderName" class="sender">
        <ng-container
          [ngTemplateOutlet]="senderTmp"
          [ngTemplateOutletContext]="{ $implicit: senderName }"
        ></ng-container>
      </div>

      <div class="message">
        <span class="text_size-s text_color-grey" [ngClass]="isSelf || !senderName ? 'text_line-2' : ' text_line-1'">
          <ng-container
            *ngIf="isSelf && !!senderName"
            [ngTemplateOutlet]="senderTmp"
            [ngTemplateOutletContext]="{ $implicit: senderName + ': ' }"
          ></ng-container>

          <app-icon
            *ngIf="lastChatMessage.icon as iconSrc"
            class="message__icon"
            [src]="iconSrc"
            [size]="'15px'"
          ></app-icon>

          {{ lastChatMessage.text | htmlToText }}
        </span>

        <app-badge
          *ngIf="unreadCount"
          [value]="unreadCount"
          [color]="item.settings?.muted ? 'grey' : 'blue'"
        ></app-badge>
      </div>
    </div>
  </div>
</div>

<ng-template #senderTmp let-senderName>
  <span class="text_color-01 text_size-s text_truncate">
    {{ senderName }}
  </span>
</ng-template>
